import React, { useCallback, useState } from "react";
import { useTranslator } from "../../../hooks/useTranslator";
import { TextAreaResize } from "../../TextArea";
import { Spiner } from "../../spiner";
import Button from "../button";
/**
 * Hook para el manejo de los mensajes
 * @param {*} param0 
 * @returns 
 */
export const useChatInput = ({ sendMessage, value = "" }) => {
    const [message, setMessages] = useState(value);
    const [loading, setLoading] = useState(false);
    const handleChange = useCallback((e) => {
        setMessages(e.target.value);
    }, []);
    const clearMessage = useCallback(() => {
        setMessages("");
    }, []);
    const _sendMessage = useCallback(() => {
        setLoading(true);
        sendMessage(message, { clearMessage })
            ?.catch(() => { })
            ?.finally(() => {
                setLoading(false);
            });
    }, [message, sendMessage, clearMessage]);
    return {
        message,
        loading,
        handleChange,
        clearMessage,
        setLoading,
        sendMessage: _sendMessage,
        bind: {
            value: message,
            onChange: handleChange,
            sendMessage: _sendMessage,
            loading
        }
    }
}

export const SendIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.34 4.02L7.34667 6.16667L2.33333 5.5L2.34 4.02ZM7.34 9.83333L2.33333 11.98V10.5L7.34 9.83333ZM1.00667 2L1 6.66667L11 8L1 9.33333L1.00667 14L15 8L1.00667 2Z" fill="#1C2540" />
        </svg>

    );
}


export const SendIcon2 = () => {
    const { t } = useTranslator();
    return (<div className="flex text-[14px] gap-2 items-center">
        <label className="hidden lg:block">{t("send")}</label>
        <SendIcon />
    </div>)
}

/**
 * Componente para el input del los mensajes
 * @returns 
 */
export const ChatInput = ({ loading, value, onChange, sendMessage, keyplaceholder }) => {

    const { t } = useTranslator();
    return (

        <div className="flex flex-col gap-4 sm-max:gap-2 w-full">
            <div
                className={`w-full min-h-16 max-h-25 bg-DarkBlue-700/90 rounded-4 sm-max:rounded-4 py-2 px-4 flex flex-row flex-grow items-center gap-2`}
            >
                <div className="flex flex-1">
                <TextAreaResize
                    value={value}
                    onChange={onChange}
                    className="resize-none overflow-auto w-full p-2 border rounded-md bg-white/13 text-Grey-500 font-semibold rounded-1 shadow placeholder:text-Grey-800 w-full p-0 text-4 bg-input text-foreground border-border data-[hover]:border-border-active data-[focus]:border-border-active"
                    placeholder={t(keyplaceholder)}
                />
                </div>
                <div className="w-[50px] lg:w-[100px] flex justify-center items-center mx-0 px-0">
                    {
                        loading ? <Spiner /> :
                            <Button
                                onClick={sendMessage}
                                type={'button'}
                                className="!py-0 m-0 rounded-6 !min-w-0"
                                variant="primary"
                            >
                                <SendIcon2 />
                            </Button>
                    }
                </div>
            </div>
        </div>
    )
}